// support for multiple spinners

<template>
    <div class="spinner loader">
        <div  v-if="!this.$store.state.site.content.spinner" 
            class="text-center"><br><i class="fa fa-circle-o-notch fa-spin fa-4x" style="color:LightGrey " ></i>
        </div>
        
        <html-renderer 
            v-else
            :template="`<div>${this.$store.state.site.content.spinner}</div>`" 
            :props="''" 
            :model="''" 
        >
        </html-renderer>
        
    </div>
</template>

<script>
    import { ContentLoader } from 'vue-content-loader'
    Vue.component('ContentLoader', ContentLoader )
    // Vue.component('ContentLoader', () => import(/* webpackChunkName: "contentloader" */   'vue-content-loader'));


    export default {
        components: {
            ContentLoader
        },
        name: 'loading',

        mounted() {
        },

        data() {
            return {}
        }
    }
</script>

<style>

</style>

                            
